import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Pagination from '../../CommonUI/Pagination/Pagination';
import './Leastvolatile.css';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'

function Leastvolatile() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [DataFundPerformance, setDataFundPerformance] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    const [Shemedrop, setSheme] = useState('26');
    // const [valueLi, setValueLi] = useState('1');
    let getDataHoldingdrop, PageSize = 5;

    useEffect(() => {
        setloadingshow(true);
        const getUrlMfTopHoldingDropDividend = BaseURL + "MfHoldingDrop";
        fetch(`${getUrlMfTopHoldingDropDividend}/compare/-`)
            .then((response) => response.json())
            .then((dataFundPerformance) => {
                getDataHoldingdrop = dataFundPerformance.data;
                setDataFundPerformance(getDataHoldingdrop);
                setloadingshow(false);
                // console.log(getDataHoldingdrop, "getDataHoldingdrop")
            })
            .catch((error) => {
            });

        const getUrl = BaseURL + "Leastvs";

        fetch(`${getUrl}/${Shemedrop}/-`)
            .then((response) => response.json())
            .then((data) => {

                setData(data.data);
                // console.log(data.data)
                setloadingshow(false);
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, [Shemedrop]);
    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    const routeChange = (paramname) => {
        window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
    }


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Least Volatile Scheme</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='leastvolatile-loser-sc'>
                            <div className='leastvolatile-header'>
                                <h2><span>Least Volatile Scheme</span></h2>
                            </div>
                            <MarketMF optionValue="Least Volatile Schemes" />
                            <div className='leastvolatile-right'>
                                <div className='leastvolatile-inner-select'>

                                    <select onChange={(event) => setSheme(event.target.value)}>
                                        {DataFundPerformance && DataFundPerformance.map(
                                            ({ VCLASSCODE, VCLASS }) => (
                                                <option value={VCLASSCODE}>{VCLASS}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='leastvolatile-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text=left'>Scheme Name</th>
                                            <th className='text-right'>Standard Deviation</th>
                                            <th className='text-right'>3 Month Return(%)</th>
                                            <th className='text-right'>1 Year Return(%)</th>
                                            <th className='text-right'>3 Year Return(%)</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ SCH_NAME, Standard_Deviation, month3, year1, year3 }) => (
                                                <tr>
                                                    <td className="text-left"><h6 onClick={() => routeChange(SCH_NAME)}>{SCH_NAME}</h6></td>
                                                    <td className='text-right'>{(Standard_Deviation != null) ? Standard_Deviation.toFixed(2) : 0}</td>
                                                    <td className='text-right'>{(month3 != null) ? month3.toFixed(2) : 0}</td>
                                                    <td className='text-right'>{(year1 != null) ? year1.toFixed(2) : 0}</td>
                                                    <td className='text-right'>{(year3 != null) ? year3.toFixed(2) : 0}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Leastvolatile;